import { usePermissions } from '~/composables/usePermissions'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('permission', {
    mounted(el, binding) {
      const { hasPermission } = usePermissions()
      
      // Parse the directive value
      // Format: 'resourceType:action' e.g., 'app:create'
      const [resourceType, action] = binding.value.split(':')
      
      if (!resourceType || !action) {
        console.error('v-permission directive requires format "resourceType:action"')
        if (binding.modifiers.hide) {
          el.style.display = 'none'
        }
        return
      }
      
      // Check if user has the permission
      const permitted = hasPermission(resourceType, action)
      
      // Handle the element based on permission check
      if (!permitted) {
        if (binding.modifiers.hide) {
          // Hide the element if .hide modifier is used
          el.style.display = 'none'
        } else {
          // Disable the element by default
          el.disabled = true
          el.classList.add('permission-disabled')
          
          // Add tooltip explaining why it's disabled
          el.setAttribute('title', `You don't have permission to ${action} ${resourceType}`)
        }
      }
    }
  })
})
